import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import {
  Dialog,
  FlatButton,
  CircularProgress,
  TextField,
  RadioButton,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  RaisedButton,
} from 'material-ui';
import ReactSelect from 'react-select';
import SingleTemplate from './single-template';

const OmniImport = props => {
  const {
    data: {
      sourceTemplate,
      targetTemplate,
      step,
      matches,
      showCC,
      searchInput,
      templates = [],
      loadingCCTemplates,
      noNeedToMatch,
      forNewDraft,
      importPoliciesNotes,
    },
    onRequestClose,
    onTextFieldChangeWithKeyPath,
    selectSourceTemplate,
    omniImport,
    saving,
    searchCCTemplates,
    importOwnTemplate: importOwnTemplateFunc,
    openGlobalAlert,
    isAnAdmin,
    loadProducts,
  } = props;
  const importOwnTemplate = () => importOwnTemplateFunc(forNewDraft);
  const updateData = (key, value) => onTextFieldChangeWithKeyPath({ keyPath: ['data', key], value });
  const selectTemplate = template => () => {
    selectSourceTemplate(template);
  };
  const uniqProducts = sourceTemplate && sourceTemplate.products
    ? R.uniqBy(p => p.productId, sourceTemplate.products)
    : [];
  const selectedTargetProducts = R.values(matches).filter(x => x).reduce((result, prod) => {
    result[prod.value] = true;
    return result;
  }, {});

  const onSearch = () => {
    if (searchInput.trim().length < 6) {
      openGlobalAlert({ text: 'Please type more than 6 characters.' });
    } else {
      searchCCTemplates(targetTemplate.locationId, searchInput);
    }
  };
  const onChangeSearchInput = e => {
    if (e.keyCode === 13) onSearch();
    else updateData('searchInput', e.target.value);
  };
  // const openInNewWindow = doc => () => {
  //   window.open(doc.magicLink);
  // };
  const clickImport = () => {
    let warningText = '';
    if (!importPoliciesNotes && !(sourceTemplate.productsToImport && sourceTemplate.productsToImport.length)) {
      warningText = 'Please select at least one item to import';
    } else if (!noNeedToMatch && sourceTemplate.productsToImport && sourceTemplate.productsToImport.length) {
      if (sourceTemplate.productsToImport.some(pId => !matches[pId])) {
        warningText = 'Please make sure every room type/product you want to import is mapped to one destination from the Import To dropdown menu.';
      }
    }
    if (warningText) {
      openGlobalAlert({
        text: warningText,
      });
    } else {
      const onOk = () => omniImport({
        matches,
        // if DL entered a contract, swap the _id as templateId so that the backend can process correctly
        sourceTemplate: (() => {
          if (sourceTemplate.idFromTCAdmin) {
            if (sourceTemplate.templateId) {
              return {
                ...sourceTemplate,
                _id: sourceTemplate.templateId,
              };
            }
            return {
              ...sourceTemplate,
              [sourceTemplate.collection === 'template' ? '_id' : 'originalContractId']: sourceTemplate.idFromTCAdmin,
            };
          }
          return sourceTemplate;
        })(),
        targetTemplateId: targetTemplate.docId,
        importAllBool: Boolean(isAnAdmin),
        importPoliciesNotes,
      });
      if (forNewDraft) {
        onOk();
      } else {
        openGlobalAlert({
          text: 'This action will overwrite the data you currently have, do you want to proceed?',
          onOk,
        });
      }
    }
  };
  const manuallyEnterId = (id, collection) => {
    if (id && collection) loadProducts({ idFromTCAdmin: id, collection });
    else updateData('sourceTemplate', { idFromTCAdmin: id, collection });
  };
  return (
    <Dialog
      open
      bodyStyle={{ minHeight: '300px' }}
      titleStyle={{ padding: '12px 12px 10px' }}
      title={
        <div className="flex-center">
          <span>Import Rates</span>
          <Stepper activeStep={step === 'selectTemplate' ? 1 : 2} style={{ width: '80%' }}>
            <Step>
              <StepLabel style={{ height: '36px' }}>Import Options</StepLabel>
            </Step>
            <Step>
              <StepLabel style={{ height: '36px' }}>Select a Template</StepLabel>
            </Step>
            <Step>
              <StepLabel style={{ height: '36px' }}>Choose Products/Rooms</StepLabel>
            </Step>
          </Stepper>
        </div>
      }
      autoScrollBodyContent
      actionsContainerClassName="flex-tc-sb"
      actions={[
        <RaisedButton
          key="own"
          label="Back"
          labelStyle={{ textTransform: 'none' }}
          onClick={step === 'matchProducts' ? () => updateData('step', 'selectTemplate') : importOwnTemplate}
        />,
        <div key="action">
          <FlatButton
            label="dismiss"
            primary
            onClick={onRequestClose}
          />
          {
            step === 'selectTemplate' ? (
              <FlatButton
                label="Next"
                secondary
                onClick={() => updateData('step', 'matchProducts')}
                disabled={!(sourceTemplate && (sourceTemplate._id || sourceTemplate.originalContractId || sourceTemplate.idFromTCAdmin))
                  || sourceTemplate.loadingProducts
                }
              />
            ) : (
              <FlatButton
                label="Import"
                secondary
                onClick={clickImport}
                disabled={saving}
              />
            )
          }
        </div>,
      ]}
    >
      {
        step === 'selectTemplate'
        ? (
            <div>
              <div style={{ margin: '1em 0', display: isAnAdmin ? 'flex' : 'none' }} className="flex-center">
                <RadioButton
                  label="Manually Enter Data"
                  checked={!showCC}
                  onCheck={() => updateData('showCC', false)}
                />
                <RadioButton
                  label="Search TourConnect Database"
                  checked={showCC}
                  onCheck={() => updateData('showCC', true)}
                />
              </div>
              {
                showCC ? (
                  <div style={{ marginTop: '1em' }}>
                    <span style={{ color: '#000' }}>Search by location/property name</span>
                    <br/>
                    <div style={{ height: '16px', lineHeight: '16px', fontSize: '10px' }}>
                      {
                        Boolean(searchInput.trim() && searchInput.trim().length < 6) && 'Type more than 6 characters to search'
                      }
                    </div>
                    <input
                      style={{ border: '1px solid #00bcd4', padding: '6px', width: '580px', borderRadius: '2px' }}
                      value={searchInput}
                      onKeyDown={onChangeSearchInput}
                      onChange={onChangeSearchInput}
                    />&nbsp;&nbsp;
                    <RaisedButton
                      label="Search"
                      secondary
                      style={{ marginLeft: '12px' }}
                      onClick={onSearch}
                    />
                    <br/>
                    {
                      (() => {
                        if (loadingCCTemplates) {
                          return (<CircularProgress style={{ margin: '1em' }}/>);
                        }
                        if (!templates.length) {
                          return (
                            <div style={{ marginTop: '1em', fontSize: '10px' }}>
                              No templates found. (Please try a different search.)
                            </div>
                          );
                        }
                        if (templates.length) {
                          return (
                            <div style={{ marginTop: '1em' }}>
                              {templates.map(t => {
                                if (t.originalContractId === targetTemplate.docId) return null;
                                return (
                                  <SingleTemplate
                                    key={t._id || t.originalContractId}
                                    template={t}
                                    selected={sourceTemplate && (sourceTemplate.originalContractId
                                      ? sourceTemplate.originalContractId === t.originalContractId : sourceTemplate._id === t._id)}
                                    onSelect={selectTemplate(t)}
                                    onUnselect={selectTemplate()}
                                    forCCImport
                                  />
                                );
                              })}
                            </div>
                          );
                        }
                      })()
                    }
                  </div>
                ) : (
                  <div>
                    <div>Enter Contract/Template/Draft Id:</div>
                    <TextField
                      value={sourceTemplate.idFromTCAdmin}
                      onChange={e => manuallyEnterId(e.target.value, sourceTemplate.collection)}
                    />
                    <div>
                      <RadioButton
                        value="draft"
                        label="Draft"
                        checked={sourceTemplate.collection === 'draft'}
                        onCheck={() => manuallyEnterId(sourceTemplate.idFromTCAdmin, 'draft')}
                      />
                      <RadioButton
                        value="template"
                        label="Template"
                        checked={sourceTemplate.collection === 'template'}
                        onCheck={() => manuallyEnterId(sourceTemplate.idFromTCAdmin, 'template')}
                      />
                      <RadioButton
                        value="contract"
                        label="Contract"
                        checked={sourceTemplate.collection === 'contract'}
                        onCheck={() => manuallyEnterId(sourceTemplate.idFromTCAdmin, 'contract')}
                      />
                    </div>
                  </div>
                )
              }
            </div>
          )
        : (
            <div style={{ padding: '1em 0 0' }}>
              <div style={{ marginBottom: '1em', color: '#000' }}>
                <Checkbox
                  checked={Boolean(importPoliciesNotes)}
                  label="Check this if you would like to import Policies and Notes"
                  onCheck={(_, checked) => updateData('importPoliciesNotes', checked)}
                />
              </div>
              <div className="flex-tc-sb" style={{ marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e0e0e0' }}>
                <div style={{ width: '50%' }}>
                  <Checkbox
                    label="Import Room Types/Products"
                    labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
                    checked={Boolean(sourceTemplate.productsToImport.length && uniqProducts.length === sourceTemplate.productsToImport.length)}
                    onCheck={(_, checked) => updateData(
                      'sourceTemplate',
                      {
                        ...sourceTemplate,
                        productsToImport: checked ? uniqProducts.map(prod => prod.productId) : [],
                      }
                    )}
                  />
                </div>
                <div
                  style={{
                    width: '50%',
                    visibility: !noNeedToMatch ? 'visible' : 'hidden',
                    color: 'rgba(0, 0, 0, 0.54)',
                  }}
                >
                  Import To
                </div>
              </div>
              {
                uniqProducts.map((prod, i) => {
                  const selected = (sourceTemplate.productsToImport || []).indexOf(prod.productId) > -1;
                  return (
                    <div key={i} className="flex-tc-sb" style={{ marginBottom: '8px', paddingLeft: '16px' }}>
                      <div style={{ width: 'calc(50% - 16px)' }}>
                        <Checkbox
                          checked={selected}
                          label={prod.productName}
                          onCheck={(_, checked) => updateData(
                            'sourceTemplate',
                            {
                              ...sourceTemplate,
                              productsToImport: checked ? [...sourceTemplate.productsToImport, prod.productId]
                                : sourceTemplate.productsToImport.filter(x => x !== prod.productId),
                            }
                          )}
                        />
                      </div>
                      <div
                        style={{
                          width: '50%',
                          visibility: !noNeedToMatch && selected ? 'visible' : 'hidden',
                        }}
                      >
                        <ReactSelect
                          placeholder="Import To..."
                          options={[
                            { label: '<New Product>', value: null },
                            ...targetTemplate.products
                            .filter(p => !selectedTargetProducts[p.productId])
                            .map(p => ({ label: p.productName, value: p.productId })),
                          ]}
                          value={matches[prod.productId]}
                          menuIsOpen
                          onChange={option => updateData('matches', { ...matches, [prod.productId]: option })}
                        />
                      </div>
                    </div>
                  );
                })
              }
            </div>
          )
      }
    </Dialog>
  );
};

const mapState = ({ user }) => ({
  isAnAdmin: user.get('isAnAdmin'),
});

OmniImport.propTypes = {
  data: React.PropTypes.object,
  onRequestClose: React.PropTypes.func,
  templates: React.PropTypes.array,
  onTextFieldChangeWithKeyPath: React.PropTypes.func,
  selectSourceTemplate: React.PropTypes.func,
  omniImport: React.PropTypes.func,
  saving: React.PropTypes.bool,
  openRateDocIframe: React.PropTypes.func,
  searchCCTemplates: React.PropTypes.func,
  isAnAdmin: React.PropTypes.bool,
  importOwnTemplate: React.PropTypes.func,
  openGlobalAlert: React.PropTypes.func,
  loadProducts: React.PropTypes.func,
};

export default connect(mapState, {
  loadProducts: template => ({ type: 'LOAD_PRODUCTS_FOR_OMNI_IMPORT_SOURCE_TEMPLATE', payload: { template } }),
  selectSourceTemplate: template => ({ type: 'SELECT_OMNI_IMPORT_SOURCE_TEMPLATE', payload: { template } }),
  omniImport: payload => ({ type: 'OMNI_IMPORT', payload }),
  searchCCTemplates: (locationId, searchInput) => ({
    type: 'SEARCH_CC_RATES_TEMPLATES',
    payload: { locationId, searchInput },
  }),
  importOwnTemplate: forNewDraft => ({
    type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE',
    payload: { type: 'importFromTemplate', data: { forNewDraft } },
  }),
  openGlobalAlert: payload => ({
    type: 'open_global_alert',
    payload,
  }),
})(OmniImport);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/import-template/omni-import.jsx